<section class="create-account">
  <div class="property-flow-steps" *ngIf="isPropertyFlow">
    <div class="step">1</div>
    <div class="line"></div>
    <div class="step active">2</div>
    <span>Regístrate con la opción que desees</span>
  </div>

  <div class="ggi-tab-container">
    <div class="ggi-tab" [ngClass]="{ active: isProspect }">
      <p class="subtitule-2" (click)="isProspect = true; generateForm()">
        Registrar como invitado
      </p>
    </div>
    <div class="ggi-tab" [ngClass]="{ active: !isProspect }">
      <p class="subtitule-2" (click)="isProspect = false; generateForm()">
        Crea una cuenta
      </p>
    </div>
  </div>

  <div class="main-container-request-visit">
    <div class="register-warning">
      <h4>Recuerda que si te registras, en tu cuenta podrás:</h4>
      <div class="item">
        <div class="point"></div>
        <div class="text">Agregar invitados a tu visita</div>
      </div>
      <div class="item">
        <div class="point"></div>
        <div class="text">Ver los detalles de tu vista y su resumen</div>
      </div>
      <div class="item">
        <div class="point"></div>
        <div class="text">Agregar notas durante la visita</div>
      </div>
      <img src="/assets/img/logos/smart-walk-s.svg" />
    </div>

    <div class="form-section property-flow">
      <section class="buttons-social-media" *ngIf="!isProspect">
        <button
          type="button"
          class="btn-google"
          (click)="signInWithSocialMedia(SocialLoginEnum.GOOGLE)"
        >
          <div class="container-button">
            <div class="container-icon">
              <img src="/assets/img/icons/icon-Social-Google.svg" />
            </div>
            <p>Regístrate con Google</p>
          </div>
        </button>

        <button
          type="button"
          class="btn-facebook"
          (click)="signInWithSocialMedia(SocialLoginEnum.FACEBOOK)"
        >
          <div class="container-button">
            <div class="container-icon">
              <span class="icon-Facebook"></span>
            </div>
            <p>Regístrate con Facebook</p>
          </div>
        </button>
      </section>

      <section class="separator" *ngIf="!isProspect">
        <hr />
        <p class="subtitule-2">o</p>
        <hr />
      </section>

      <form [formGroup]="form" autocomplete="off">
        <div class="form-row" *ngIf="!isProspect">
          <div class="ggi-input">
            <input
              type="text"
              formControlName="firstName"
              id="name"
              ggiJourneyControlValidator
              [submitted]="form.get('firstName')?.touched"
            />
            <label for="name">Nombre</label>
          </div>
          <div class="ggi-input">
            <input
              type="text"
              formControlName="lastName"
              id="lastName"
              ggiJourneyControlValidator
              [submitted]="form.get('lastName')?.touched"
            />
            <label for="lastName">Apellidos</label>
          </div>
        </div>
        <div class="form-row">
          <div class="ggi-input" *ngIf="!isProspect">
            <input
              type="text"
              formControlName="phone"
              id="phone"
              [mask]="MaskPhone"
              ggiJourneyControlValidator
              [submitted]="form.get('phone')?.touched"
            />
            <label for="phone">Teléfono</label>
          </div>
          <div
            class="ggi-input"
            *ngIf="!changeEmail"
            [ngClass]="{ prospect: isProspect }"
          >
            <input
              type="text"
              formControlName="email"
              id="email"
              ggiJourneyControlValidator
              [submitted]="form.get('email')?.touched"
            />
            <label for="email">
              {{ isProspect ? 'Correo Electrónico' : 'Correo' }}
            </label>
          </div>
        </div>
        <div class="form-row" *ngIf="!isProspect">
          <div class="ggi-input password-input">
            <input
              type="password"
              formControlName="password"
              id="password"
              ggiJourneyControlValidator
              [submitted]="form.get('password')?.touched"
              [attr.type]="showPassword ? 'text' : 'password'"
            />
            <label for="password">Contraseña</label>
            <button
              class="btn-show-pass"
              type="button"
              tabindex="-1"
              (click)="changePasswordType()"
            >
              <span *ngIf="!showPassword" class="icon-Eye-Opened"></span>
              <span *ngIf="showPassword" class="icon-Eye-Closed"></span>
            </button>
          </div>
          <div class="ggi-input password-input">
            <input
              type="password"
              formControlName="confirmPassword"
              id="confirmPassword"
              ggiJourneyControlValidator
              [submitted]="form.get('confirmPassword')?.touched"
              [attr.type]="showPasswordConfirm ? 'text' : 'password'"
            />
            <label for="confirmPassword">Confirmar contraseña</label>
            <button
              class="btn-show-pass"
              type="button"
              tabindex="-1"
              (click)="changePasswordType('confirm')"
            >
              <span *ngIf="!showPasswordConfirm" class="icon-Eye-Opened"></span>
              <span *ngIf="showPasswordConfirm" class="icon-Eye-Closed"></span>
            </button>
          </div>
        </div>
        <div class="form-row">
          <div class="ggi-checkbox">
            <input
              type="checkbox"
              formControlName="acceptPoliciesAndTerms"
              id="acceptPoliciesAndTerms"
            />
            <label for="acceptPoliciesAndTerms">He leído y acepto el </label>
            <a class="url" (click)="openTerms()">Aviso de privacidad</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
